import React from "react";
import { HeaderTitle, HeaderWrapper } from "./MarketHomeHeaderStyle";
import Search from "assets/icons/SearchBig.svg";
import BigHeart from "assets/icons/BigHeart.svg";
import { useNavigate } from "react-router-dom";

const MarketHomeHeader = ({ item }) => {
  const navigate = useNavigate();

  const onNavigateLikeList = () => {
    navigate(`/market/LikeList`);
  };
  const onNavigateMarketSearch = () => {
    navigate("/market/search")
  }
  return (
    <HeaderWrapper>
      <img
        className="like"
        src={BigHeart}
        alt="Back Link button"
        onClick={() => {
          onNavigateLikeList();
        }}
      />
      <HeaderTitle>시장정보</HeaderTitle>
      <img
        className="search"
        src={Search}
        alt="Back Link button"
        onClick={onNavigateMarketSearch}
      />
    </HeaderWrapper>
  );
};

export default MarketHomeHeader;
